import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';

export default class BackArrow extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object,
    defaultBackPath: PropTypes.string,
    className: PropTypes.string
  };

  returnBack = () => {
    const { history, location, defaultBackPath } = this.props;
    let cantReturnBack, backPath;
    if (location && location.state) {
      cantReturnBack = location.state.cantReturnBack;
      backPath = location.state.backPath;
    }
    if (backPath) {
      this.props.history.push(backPath);
    } else if (history.action === 'PUSH' && !cantReturnBack) {
      // we need to prevent cases when the page was refreshed and there is no back route (POP action in such cases)
      // or when we shouldn't return back according to business logic (example: job creation page)
      this.props.history.goBack();
    } else if (defaultBackPath) {
      this.props.history.push(defaultBackPath);
    } else {
      this.props.history.push('/');
    }
  };

  render () {
    return (
      <button className={`back-arrow-icon non-button ${this.props.className || ''}`} onClick={this.returnBack}>
        <FontAwesomeIcon icon={faArrowCircleLeft} />
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ui/BackArrow.js